module.exports = __webpack_public_path__ + "static/img/goodness1.2ec0ff5f.png";